import { CodeDesignation } from './codeDesignation.model';

export class CodeDesignationMock {
	private code: string;
	private designation: string;

	setCode(code: string): this {
		this.code = code;
		return this;
	}

	setDesignation(designation: string): this {
		this.designation = designation;
		return this;
	}

	build(): CodeDesignation {
		let codeDesignation: CodeDesignation = new CodeDesignation();
		codeDesignation.code = this.code;
		codeDesignation.designation = this.designation;
		return codeDesignation;
	}
}
